import {
  DatabaseZap,
  FileSpreadsheet,
  LayoutDashboard,
  Mail,
  Megaphone,
  Package,
  Settings,
  Users,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface NavItem {
  /** Absolute route under the /app prefix. */
  to: string;
  labelKey: string;
  icon: LucideIcon;
  /** Paid feature: shows the Pro badge and is gated behind `effective_plan`. */
  pro?: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: "/app/dashboard", labelKey: "nav.dashboard", icon: LayoutDashboard },
  { to: "/app/sources", labelKey: "nav.dataSources", icon: DatabaseZap },
  { to: "/app/sku", labelKey: "nav.sku", icon: Package },
  { to: "/app/ads", labelKey: "nav.ads", icon: Megaphone, pro: true },
  { to: "/app/customers", labelKey: "nav.customers", icon: Users, pro: true },
  { to: "/app/emails", labelKey: "nav.emails", icon: Mail, pro: true },
  { to: "/app/reports", labelKey: "nav.reports", icon: FileSpreadsheet, pro: true },
  { to: "/app/settings", labelKey: "nav.settings", icon: Settings },
];
